export const block = { display: 'block' };

export const sizerWrapperStyles = {
  ...block,
  position: 'absolute',
  left: '-20000px',
  width: '100%',
};

export const spreaderStyles = {
  ...block,
  overflow: 'hidden',
  height: '0px',
  width: '100%',
};

export const wrapperStyles = {
  ...block,
  position: 'relative',
  overflow: 'hidden',
};

export const childrenStyles = {
  ...block,
  width: '100%',
};
